"use strict";
/**
 * @deprecated
 * 此文件不再继续使用和维护
 * 使用Network代替
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkUtils = void 0;
const axios_1 = __importDefault(require("axios"));
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const dataRetrive_1 = require("../dataRetrive");
const Error_1 = require("../error/Error");
const Tools_1 = require("./Tools");
const ObservableUtilsHelper_1 = require("./ObservableUtilsHelper");
/**
 * @deprecated
 * 使用Network代替
 */
exports.NetworkUtils = {
    /**
     * @deprecated
     * 使用Network代替
     */
    getCDN(params) {
        const _header = Object.assign({ "Cache-Control": "max-age=0", "Content-Type": "application/json;charset=UTF-8" }, params.headers);
        return (0, rxjs_1.from)(axios_1.default.get(params.url, { headers: _header })).pipe((0, operators_1.map)((response) => response.data));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    postWithTradeAuth(params) {
        const { url, headers, data } = params;
        return (0, dataRetrive_1.getTradeDependencyInstance)()
            .getTradingToken()
            .pipe((0, operators_1.mergeMap)((tradingTokenInfo) => {
            if (!tradingTokenInfo) {
                throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.TradeUnAuthorized, "trade_unAuthorized", { url: url });
            }
            else {
                const authHeader = Object.assign(Object.assign({}, headers), { Authorization: `Bearer ${tradingTokenInfo.tradingToken}` });
                return exports.NetworkUtils.post({ url, headers: authHeader, data });
            }
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    getWithTradeAuth(params) {
        const { url, headers, data } = params;
        return (0, dataRetrive_1.getTradeDependencyInstance)()
            .getTradingToken()
            .pipe((0, operators_1.mergeMap)((tradingTokenInfo) => {
            if (!tradingTokenInfo) {
                throw Error_1.ErrorGenerate.generateError(Tools_1.TradeHttpErrorCode.TradeUnAuthorized, "trade_unAuthorized", { url: url });
            }
            else {
                const authHeader = Object.assign(Object.assign({}, headers), { Authorization: `Bearer ${tradingTokenInfo.tradingToken}` });
                return exports.NetworkUtils.get({ url, data, headers: authHeader });
            }
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    getWithAccessAndSpotAuth(params) {
        const { url, headers, data } = params;
        return (0, ObservableUtilsHelper_1.AccessAndSpotAuthHeaderObservable)(headers).pipe((0, operators_1.mergeMap)((authHeader) => {
            return exports.NetworkUtils.get({ url, data, headers: authHeader });
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    getWithAccessAndFuturesAuth(params) {
        const { url, headers, data } = params;
        return (0, ObservableUtilsHelper_1.AccessAndTraderAuthHeaderObservable)(headers).pipe((0, operators_1.mergeMap)((authHeader) => {
            return exports.NetworkUtils.get({ url, data, headers: authHeader });
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    getWithFullTokenAuth(params) {
        const { url, headers, data } = params;
        return (0, ObservableUtilsHelper_1.FullTokenAuthHeaderObservable)(headers).pipe((0, operators_1.mergeMap)((authHeader) => {
            return exports.NetworkUtils.get({ url, data, headers: authHeader });
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    postWithAccessAndSpotAuth(params) {
        const { url, headers, data } = params;
        return (0, ObservableUtilsHelper_1.AccessAndSpotAuthHeaderObservable)(headers).pipe((0, operators_1.mergeMap)((authHeader) => {
            return exports.NetworkUtils.post({ url, data, headers: authHeader });
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    deleteWithAccessAndSpotAuth(params) {
        const { url, headers, data } = params;
        return (0, ObservableUtilsHelper_1.AccessAndSpotAuthHeaderObservable)(headers).pipe((0, operators_1.mergeMap)((authHeader) => {
            return exports.NetworkUtils.delete({ url, data, headers: authHeader });
        }));
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    post(params) {
        const { url, headers, data, authorize = false, withBearer = false } = params;
        const requestObservable = (0, ObservableUtilsHelper_1.processAccessNetworkHeader)(authorize, headers, withBearer).pipe((0, operators_1.mergeMap)((_header) => {
            return (0, Tools_1.createPostRequestObservable)(url, _header, data, (response) => {
                return response;
            });
        }));
        return (0, Tools_1.resolveResponse)(requestObservable);
    },
    /**
     * @deprecated Instead of post with params withBearer
     * postV2 在需要签名时，默认签名头部会有Bearer
     */
    postV2(params) {
        const { url, headers, data, authorize = false, withBearer = true } = params;
        return this.post({ url, headers, data, authorize, withBearer });
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    get(params) {
        const { url, headers, data, authorize = false, withBearer = false } = params;
        const requestObservable = (0, ObservableUtilsHelper_1.processAccessNetworkHeader)(authorize, headers, withBearer).pipe((0, operators_1.mergeMap)((_header) => {
            return (0, Tools_1.createGetRequestObservableV2)(url, _header, data, (response) => {
                return response;
            });
        }));
        return (0, Tools_1.resolveResponse)(requestObservable);
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    getV2(params) {
        const { url, headers, data, authorize = false, withBearer = true } = params;
        return this.get({ url, headers, data, authorize, withBearer });
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    delete(params) {
        const { url, headers, data, authorize = false, withBearer = true } = params;
        const requestObservable = (0, ObservableUtilsHelper_1.processAccessNetworkHeader)(authorize, headers, withBearer).pipe((0, operators_1.mergeMap)((_header) => {
            return (0, Tools_1.createDeleteRequestObservableV2)(url, _header, data, (response) => {
                return response;
            });
        }));
        return (0, Tools_1.resolveResponse)(requestObservable);
    },
    /**
     * @deprecated
     * 使用Network代替
     */
    postThrowable(params) {
        const { url, headers, data, authorize = false, withBearer = false } = params;
        return (0, ObservableUtilsHelper_1.processAccessNetworkHeader)(authorize, headers, withBearer).pipe((0, operators_1.mergeMap)((_header) => {
            return (0, rxjs_1.from)(axios_1.default.post(url, data, (0, Tools_1.createAxiosRequestConfig)(url, _header)));
        }), (0, operators_1.map)((resp) => resp));
    },
};
